<template>
  <div>
    <q-btn
      v-if="!promptForGiftCard"
      align="between"
      icon-right="arrow_forward"
      class="full-width q-py-xs text-uppercase text-weight-bolder text-overline"
      style="font-size: 12px; border: 1px solid rgba(0,0,0,0.12);"
      label="Add Gift Card"
      @click="$emit('show-gift-card', true)"
    />
    <q-btn
      v-if="promptForGiftCard"
      class="full-width q-py-xs text-uppercase text-weight-bolder text-overline"
      style="font-size: 12px; border: 1px solid rgba(0,0,0,0.12);"
      align="between"
      icon-right="arrow_forward"
      label="Hide Gift Card"
      @click="$emit('show-gift-card', false)"
    />
    <q-btn
      class="full-width q-py-xs text-uppercase text-weight-bolder text-overline"
      style="font-size: 12px; border: 1px solid rgba(0,0,0,0.12);"
      align="between"
      icon-right="arrow_forward"
      label="Other Payment"
      @click="$emit('show-other-payment')"
    />
    <q-btn
      v-if="orderCanTransferTab"
      class="full-width q-py-xs text-uppercase text-weight-bolder text-overline"
      style="font-size: 12px; border: 1px solid rgba(0,0,0,0.12);"
      align="between"
      icon-right="arrow_forward"
      label="Transfer Tab"
      @click="$emit('show-incoming-employee')"
    />
    <q-card
      class=" q-pl-md"
      flat
      bordered
    >
      <div
        class="full-width row justify-start"
      >
        <div
          class="q-py-xs text-uppercase text-weight-bolder text-overline"
        >
          Split

          <div v-if="split">
            <div v-if="splitRatio">
              {{ splitRatio }}x
            </div>
            <i18n-n
              v-else
              :value="splitAmount"
              format="currency"
              scope="global"
            />
          </div>
        </div>
        <q-toggle
          :model-value="split"
          style="margin-left: auto;"
          :disable="paymentConnectorPaymentInProgress"
          class="col-auto"
          @update:model-value="value => $emit('split', value)"
        />
        <q-btn
          v-if="split"
          icon="edit"
          flat
          round
          dense
          class="col-auto"
          @click="$emit('split', true)"
        />
      </div>
      <div
        v-if="showTaxable"
        class="full-width row justify-start"
      >
        <div
          class="q-py-xs text-uppercase text-weight-bolder text-overline"
        >
          {{ taxExempt ? 'Exempt' : 'Taxable' }}
        </div>
        <q-toggle
          :model-value="taxExempt"
          style="margin-left: auto;"
          :disable="paymentConnectorPaymentInProgress"
          keep-color
          :color="taxExempt ? 'red' : 'green'"
          unchecked-icon="check"
          checked-icon="clear"
          @update:model-value="value => $emit('tax-exempt', value)"
          @click.stop
        />
      </div>
      <div
        v-if="showEmailReceipt"
        class="full-width row justify-start"
      >
        <div
          class="q-py-xs text-uppercase text-weight-bolder text-overline"
        >
          Email Receipt
        </div>
        <q-toggle
          :model-value="emailReceipt"
          style="margin-left: auto;"
          keep-color
          :color="emailReceipt ? 'green' : 'grey'"
          unchecked-icon="email"
          checked-icon="email"
          @update:model-value="value => $emit('email-receipt', value)"
          @click.stop
        />
      </div>
      <div
        v-if="$register"
        class="full-width row justify-start"
      >
        <div
          class="q-py-xs text-uppercase text-weight-bolder text-overline"
        >
          Print Receipt
        </div>
        <q-toggle
          :model-value="printReceipt"
          style="margin-left: auto;"
          keep-color
          :color="printReceipt ? 'green' : 'grey'"
          unchecked-icon="receipt"
          checked-icon="receipt"
          @update:model-value="value => $emit('print-receipt', value)"
          @click.stop
        />
      </div>
    </q-card>
  </div>
</template>

<script>
export default {
  name: 'MobileOrderOptionList',
  props: {
    splitAmount: {
      type: Number,
      required: false,
      default: 0
    },
    splitRatio: {
      type: Number,
      required: false,
      default: 0
    },
    split: {
      type: Boolean,
      required: false,
      default: false
    },
    showTaxable: {
      type: Boolean,
      required: false,
      default: false
    },
    taxExempt: {
      type: Boolean,
      required: false,
      default: false
    },
    showEmailReceipt: {
      type: Boolean,
      required: false,
      default: false
    },
    emailReceipt: {
      type: Boolean,
      required: false,
      default: false
    },
    showPrintReceipt: {
      type: Boolean,
      required: false,
      default: false
    },
    printReceipt: {
      type: Boolean,
      required: false,
      default: false
    },
    paymentConnectorPaymentInProgress: {
      type: Boolean,
      required: false,
      default: false
    },
    promptForGiftCard: {
      type: Boolean,
      required: false,
      default: false
    },
    orderCanTransferTab: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['show-gift-card', 'show-other-payment', 'show-incoming-employee', 'split', 'tax-exempt', 'email-receipt', 'print-receipt']
}
</script>
